import { Button, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type DocumentsUploadLandingProps = {
  onUploadDocument: () => void;
  onUploadFromSharePoint: () => void;
};

export default function DocumentsUploadLanding({
  onUploadDocument,
  onUploadFromSharePoint,
}: DocumentsUploadLandingProps) {
  return (
    <Stack
      align="center"
      justify="center"
      gap="lg"
      py="xxxxl"
      data-testid="documents-upload-landing"
    >
      <Stack gap="sm" align="center">
        <Text size="displayXs" fw={FONT_WEIGHTS.medium} c="gray.10" ta="center" lh="32px">
          Turn documents
          <br />
          into structured client data
        </Text>
        <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.8" ta="center" maw={420}>
          Upload fact finds, statements or meeting notes — Siesta AI will extract key information
          and update the client profile automatically.
        </Text>
      </Stack>
      <Stack gap="xxs" w="100%" maw={360}>
        <Button
          color="brand.6"
          radius="xl"
          fullWidth
          fw={FONT_WEIGHTS.bold}
          onClick={onUploadDocument}
          data-testid="upload-document-button"
        >
          Upload document
        </Button>
        <Button
          variant="light"
          color="brand"
          radius="xl"
          fullWidth
          fw={FONT_WEIGHTS.bold}
          onClick={onUploadFromSharePoint}
          data-testid="upload-from-share-point-button"
        >
          Upload from SharePoint
        </Button>
      </Stack>
    </Stack>
  );
}
